import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ComParentChildService } from 'src/app/service/com-parent-child.service';
var ShowRemarkDataComponent = /** @class */ (function () {
    function ShowRemarkDataComponent(modalRef, comparentchildservice) {
        this.modalRef = modalRef;
        this.comparentchildservice = comparentchildservice;
    }
    ShowRemarkDataComponent.prototype.ngOnInit = function () {
    };
    ShowRemarkDataComponent.prototype.cancelPopup = function () {
        this.modalRef.hide();
        this.modalRef = null;
    };
    return ShowRemarkDataComponent;
}());
export { ShowRemarkDataComponent };
